import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchProjects, fetchProjectCategories } from '../../services/api';
import { updateProjectCategory, reorderProjects } from '../../services/adminApi';
import Loader from '../../components/admin/ui/Loader';
import EntityTable from '../../components/admin/EntityTable';
import EntityForm from '../../components/admin/EntityForm';
import EntityFormPage from '../../components/admin/EntityFormPage';
import ImagePreview from '../../components/admin/ui/ImagePreview';
import { projectCategoryFields } from '../../config/admin/projects.config';

const categoryProjectColumns = [
  {
    key: 'nom',
    label: 'Projet',
    render: (row) => (
      <div className="admin-row-media">
        <ImagePreview src={row.logo} size={28} />
        {row.nom?.fr || row.nom?.en}
      </div>
    )
  }
];

function AdminProjectCategoryEditPage({ showToast }) {
  const { categoryId } = useParams();
  const navigate = useNavigate();
  const [category, setCategory] = useState(null);
  const [categoryProjects, setCategoryProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    return Promise.all([fetchProjectCategories(), fetchProjects()]).then(([categories, projects]) => {
      setCategory((categories || []).find((c) => c.id === categoryId) || null);
      setCategoryProjects((projects || []).filter((p) => p.category === categoryId));
      setLoading(false);
    });
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryId]);

  const handleReorder = async (ids) => {
    await reorderProjects(ids);
    await load();
  };

  const handleSubmit = async (values) => {
    await updateProjectCategory(categoryId, values);
    showToast('Catégorie mise à jour.');
    navigate('/admin-bj/projets/categories');
  };

  if (loading) return <Loader label="Chargement de la catégorie..." />;

  if (!category) {
    return (
      <EntityFormPage listLabel="Catégories" title="Catégorie introuvable" onBack={() => navigate('/admin-bj/projets/categories')}>
        <p>Aucune catégorie avec cet identifiant.</p>
      </EntityFormPage>
    );
  }

  return (
    <EntityFormPage
      listLabel="Catégories"
      itemLabel={category.label?.fr || category.label?.en}
      title="Modifier la catégorie"
      onBack={() => navigate('/admin-bj/projets/categories')}
    >
      <EntityForm
        key={category.id}
        fields={projectCategoryFields}
        initialValues={category}
        onSubmit={handleSubmit}
        submitLabel="Sauvegarder"
      />

      <h3 style={{ marginTop: 'var(--space-5)', marginBottom: 'var(--space-2)' }}>
        Projets de cette catégorie
      </h3>
      <EntityTable
        columns={categoryProjectColumns}
        rows={categoryProjects}
        onEdit={(project) => navigate(`/admin-bj/projets/${project.seturl}`)}
        onReorder={handleReorder}
        emptyMessage="Aucun projet dans cette catégorie."
      />
    </EntityFormPage>
  );
}

export default AdminProjectCategoryEditPage;
